import {ApplicationConfig, inject, Injectable, isDevMode} from '@angular/core';
import {
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import {provideClientHydration, withHttpTransferCacheOptions} from '@angular/platform-browser';
import routes from "./app-routing.module";
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import {provideTransloco, Translation, TranslocoLoader} from "@ngneat/transloco";
import {intercept, LANG} from "@services";
import {provideAnimations} from "@angular/platform-browser/animations";
import {environment} from "@environment";
import {AppRouteReuseStrategy} from "./app-route-reuse.strategy";
import {forkJoin} from "rxjs";
import {map} from "rxjs/operators";
import {FooterComponent} from '@components';
import {LyIconService} from "@alyle/ui/icon";
import {LY_THEME, LY_THEME_NAME, LyRippleService, LyTheme2} from "@alyle/ui";
import {MinimaDark, MinimaLight} from "@alyle/ui/themes/minima";

export const AVAILABLE_LANGUAGES: string[] = ['hr', 'en', 'it', 'slo', 'sr', 'bs', 'de', 'fr', 'es'];

function getDefaultLang() {
  var defaultLang: string = 'en';
  if (typeof window !== 'undefined') {
    if (localStorage.getItem(LANG) != null && localStorage.getItem(LANG) != undefined && AVAILABLE_LANGUAGES.includes(localStorage.getItem(LANG)!)) {
      defaultLang = localStorage.getItem(LANG)!;
    }
  }
  return defaultLang;
}

@Injectable({ providedIn:'any' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http: HttpClient = inject(HttpClient);

  getTranslation(lang: string) {
    const files = [`/assets/i18n/${lang}.json`, `/assets/i18n/text_${lang}.json`, `/assets/i18n/countries_${lang}.json`];
    return forkJoin(files.map(file => this.http.get<Translation>(file + "?v=" + FooterComponent.clientVersion))).pipe(
      map(translations => Object.assign({}, ...translations))
    );
  }
}

export const appConfig: ApplicationConfig = {
  providers: [provideHttpClient(withFetch(), withInterceptors([intercept])),
    {provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy}, /* What should app do in case of a reroute on
     the same url, regarding component, create new or use existing, check runGuardsAndResolvers at
      app-routing.module.ts to set how resolvers are going to behave */
    provideRouter(routes, withComponentInputBinding()/*, withDebugTracing()*/,
      withInMemoryScrolling({scrollPositionRestoration: "enabled"})),
    provideClientHydration(withHttpTransferCacheOptions({
      includePostRequests: true,
      includeHeaders:['X-App-Version']
    })), provideTransloco({
      config: {
        availableLangs: AVAILABLE_LANGUAGES,
        defaultLang: getDefaultLang(),
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        fallbackLang: "hr",
        missingHandler: {
          allowEmpty: true,
          // It will use the first language set in the `fallbackLang` property
          useFallbackTranslation: true
        },
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    }), provideAnimations(),
    LyTheme2,
    LyRippleService,
    LyIconService,
    { provide: LY_THEME_NAME, useValue: 'minima-light' },
    { provide: LY_THEME, useClass: MinimaLight, multi: true },
    { provide: LY_THEME, useClass: MinimaDark, multi: true },]
};
